import * as Api from '@/api';
import router from '@/router';
import { validatePassword } from '@/utils/input_utils';
import PasswordVisibilityButton from '@/components/PasswordVisibilityButton';
import { _prepareErrors } from '@/utils/_function.js';
import { phone } from '@/utils/input_validations';
import MaskedInput from 'vue-masked-input';
import { DOMEN } from '@/api/path';

export default {
  name: 'Invite',
  data() {
    return {
      form: {
        active: true,
        firstName: null,
        middleName: null,
        lastName: null,
        phone: null,
        password: null,
        passwordConfirmation: null,
        kind: 'entity',
        token: null
      },
      error: {
        firstName: null,
        lastName: null,
        password: null,
        passwordConfirmation: null
      },
      rulesAgreement: false
    };
  },
  components: {
    PasswordVisibilityButton,
    MaskedInput
  },
  validations() {
    return {
      form: {
        phone
      }
    };
  },
  watch: {
    'form.firstName': function() {
      this.error.firstName = null;
    },

    'form.lastName': function() {
      this.error.lastName = null;
    },

    'form.phone': function() {
      this.error.phone = null;
    },

    'form.password': function() {
      this.error.password = null;
      this.error.passwordConfirmation = null;
    },

    'form.passwordConfirmation': function() {
      this.error.passwordConfirmation = null;
      this.error.password = null;
    }
  },
  created() {
    if (this.$route.query.role === 'moder') {
      this.$toastr('error', `Вы не можете зарегистрировать модератора, перейдите на ${DOMEN}`, 'Ошибка');
      router.push('/');
      return;
    }
    this.form.token = this.$route.query.token;

    if (this.form.token) {
      Api.getFilerToken({ data: { token: this.form.token } })
        .then(() => {})
        .catch(error => {
          if (error) {
            _prepareErrors(error).forEach((err) => {
              this.$toastr('error', err, 'Ошибка');
            });

            if (error.request && error.request.status === 422) {
              router.push({ path: '/' });
            }
          }
        });
    } else router.push('/');
  },
  methods: {
    checkInputValue(evt) {
      if (evt.keyCode === 32) {
        this.$toastr('error', 'Вы ввели недопустимый символ', 'Ошибка');
      }
    },

    onSubmit(evt) {
      evt.preventDefault();

      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      if (!this.form.firstName) {
        this.error.firstName = 'Введите имя.';
      }

      if (!this.form.lastName) {
        this.error.lastName = 'Введите фамилию.';
      }

      if (!this.form.phone) {
        this.error.phone = 'Введите телефон.';
      }

      if (!this.form.password) {
        this.error.password = 'Введите пароль.';
      } else if (!validatePassword(this.form.password)) {
        this.error.password = 'Пароль должен содержать минимум 8 символов, букву нижнего и букву верхнего регистров.';
      }

      if (!this.form.passwordConfirmation) {
        this.error.passwordConfirmation = 'Подтвердите пароль.';
      }

      if (this.form.password && this.form.passwordConfirmation) {
        if (this.form.password !== this.form.passwordConfirmation) {
          this.error.password = 'Пароли не совпадают';
        }
      }

      if (
        this.error.firstName ||
        this.error.lastName ||
        this.error.phone ||
        this.error.password ||
        this.error.passwordConfirmation) {
        return;
      }

      Api.addFiler({ data: this.form })
        .then(response => {
          if (response) {
            this.$toastr('success', 'Спасибо за регистрацию, данные переданы на проверку в Cлужбу поддержки.', 'Регистрация пройдена успешно');
            router.push({ path: `/` });
          }
        })
        .catch(error => {
          if (error) {
            _prepareErrors(error).forEach((err) => {
              this.$toastr('error', err, 'Ошибка');
            });

            this.$rollbar.warning(error);
            this.$toastr('error', this.$t('Регистрация не пройдена, обратитесь в Службу поддержки.'), 'Ошибка');
          }
        });
    }
  }
};
